import React, {useState} from 'react';
import './FormComponent.css'
import SatisfiedIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import DissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { Button, Checkbox, CircularProgress, FormControlLabel } from '@mui/material';
import { Container, Row, Col } from 'react-bootstrap';
import { TERMS_AND_CONDITIONS, PRIVACY_POLICY, WEEKLY_SURVEY_REDIRECT, INITIAL_SURVEY_REDIRECT } from '../../utils/constants';
import Components from '../index';
import axios from 'axios';
import { StepperComponent } from '../GetStartedComponent/GetStartedComponent';

const col8 = 8;
const col4 = 4;
const HTTP_STATUS_CODE_REDIRECT = 302
const STEPPER_LABELS = ["Register", "Short Survey"]

const FormComponent = ({initialSurvey, id, ssu}) => {

	const { SliderComponent, GetStartedComponent } = Components;

	const [isSubmitting, setIsSubmitting] = useState(false);

	const [SSUSurveyCompleted, changeSSUSurveyCompleted] = useState(false);
	const markSSUSurveyCompleted = () => {changeSSUSurveyCompleted(true)};


	// Validation Message States
	const [showCheckboxMessage, toggleShowCheckboxMessage] = useState(false);
	const [showSliderChildMessage, toggleShowSliderChildMessage] = useState(false);
	const [showSliderFamilyMessage, toggleShowSliderFamilyMessage] = useState(false);
	const [showSliderSchoolMessage, toggleShowSliderSchoolMessage] = useState(false);
	const [showSliderEverythingMessage, toggleShowSliderEverythingMessage] = useState(false);
	
	// Form Elements Control
	const [sliderChildTouched, setSliderChildTouched] = useState(false)
	const [sliderFamilyTouched, setSliderFamilyTouched] = useState(false)
	const [sliderSchoolTouched, setSliderSchoolTouched] = useState(false)
	const [sliderEverythingTouched, setSliderEverythingTouched] = useState(false)
	const [termsOfServiceTouched, setTermsOfServiceTouched] = useState(false)
	const [termsOfServiceChecked, toggleTermsOfService] = useState(false)

	// Input Values of Slider
	const [childValue, setChildValue] = useState(0)
	const [familyValue, setFamilyValue] = useState(0)
	const [schoolValue, setSchoolValue] = useState(0)
	const [everythingValue, setEverythingValue] = useState(0)

	/**
	 * Summary.
	 * changeTermsOfService is a local function that does three tasks:
	 * 1. Changes the Checkbox touch state once touched
	 * 2. Handles the toggle
	 * 3. Removes the validation message if it is checked
	 * 
	 * Description. (N/A)
	 *
	 * @since      0.1.0
	 *
	 * @param {boolean} checked      Whether the TnC Checkbox is checked or not.
	 *
	 * @return {null}
	 */
	const changeTermsOfService = (checked) => {
		if(termsOfServiceTouched) setTermsOfServiceTouched(true)
		toggleTermsOfService(!termsOfServiceChecked)
		if(checked) toggleShowCheckboxMessage(false);
	}

	/**
	 * Summary.
	 * changeSliderValue is Custom Handler to handle 4 Sliders and update the states of the state variables.
	 * Description. (N/A)
	 *
	 * @since      0.1.0
	 *
	 * @param {number}   value        				Value of Corresponding Slider.
	 * @param {function} sliderSetter				Takes the Corresponding Sider state function to update the value.
	 * @param {boolean}  sliderTouch=false 			Touch value of corresponding Sliders
	 * @param {function} sliderTouchFunction  		State Touch function to update touch value.
	 * @param {boolean}  sliderTouchHelper=false 	Validation boolean that shows or hides the validation/error message
	 *
	 * @return {null}
	 */
	const changeSliderValue = (value, sliderSetter, sliderTouch, sliderTouchFunction, sliderTouchHelper) => {
		if(!sliderTouch) 
		{
			sliderTouchFunction(true);
			sliderTouchHelper(false);
		}
		sliderSetter(value);
	}

	/**
	 * Summary.
	 * Validates the form such that all value are touched and checkbox is checked in case of Initial Survey
	 * Description. (N/A)
	 *
	 * @since      0.1.0
	 *
	 * @return {boolean} Returns the validity of form.
	 */
	const formValidated = () => {
		let control = true;
		const toggleSliderMessages = [toggleShowSliderChildMessage, toggleShowSliderFamilyMessage, toggleShowSliderSchoolMessage, toggleShowSliderEverythingMessage, toggleShowCheckboxMessage];
		[!sliderChildTouched, !sliderFamilyTouched, !sliderSchoolTouched, !sliderEverythingTouched, initialSurvey && !termsOfServiceChecked].forEach((value, index) => {
			if(value) { control = false; toggleSliderMessages[index](true);}
		})
		return control
	}

	/**
	 * Summary. (use period)
	 * Submits the form by invoking the API and handles according to response 
	 * Description. (use period)
	 *
	 * @since      0.1.0
	 *
	 * @return {null}
	 */
	const submitForm = () => {
		if(formValidated())
		{
			setIsSubmitting(true);
			// Control API 
			const formData = {
				responseID: 47713466,
    			surveyID: initialSurvey || ssu ? "INITIAL_SURVEY" : "WEEKLY_SURVEY",
				Referral: Number(id),
				responseSet: [
					{
						questionText: " Me (How am I doing?) ",
						answerValue: childValue
					},
					{
						questionText: " Family (How are things in my family?) ",
						answerValue: familyValue
					},
					{
						questionText: " School (How am I doing at school?) ",
						answerValue: schoolValue
					},
					{
						questionText: " Everything (How is everything going?) ",
						answerValue: everythingValue
					}
				]

			}
			axios.post(process.env.REACT_APP_BASE_URL,formData)
			.then((data)=> {
				const res = data.data;
				if(res && res.hasOwnProperty("statusCode") && res.hasOwnProperty("headers"))
				{
					const {statusCode, headers} = res;
					if(statusCode === HTTP_STATUS_CODE_REDIRECT && headers.hasOwnProperty("location"))
					{
						window.location.replace(headers.location)	
					}
				}
				else
				{
					if(ssu)
					{
						markSSUSurveyCompleted()
					}
					else
					{
						window.location.replace(initialSurvey ? INITIAL_SURVEY_REDIRECT : WEEKLY_SURVEY_REDIRECT)
					}
				}
			})
			.catch((reason) => {
				console.log(reason);
			})
			.finally(() => {
				setIsSubmitting(false)
			})
		}
	}
	
	
	// Generic Components to be used in component.
	const showSliderMessage = () => <div className='asterisk-text-color font-10'>Please select a value</div>
	const checkboxText = () => <>I agree to <a href={TERMS_AND_CONDITIONS} target='_blank' rel="noreferrer">Terms & Conditions</a> and have read and understood the <a href={PRIVACY_POLICY} target='_blank' rel="noreferrer">Privacy Notice</a>.<b className='asterisk-text-color'>*</b></>

	// Component JSX Tree
	return(
		<div className='dis-flex justify-space-around'>
			<div className='dis-flex flex-column flex-grow-3'></div>
			{
				!SSUSurveyCompleted && <div className='dis-flex flex-column flex-grow-4 form-component'>
					{ssu && <div className='dis-flex flex-column'>
						<StepperComponent step={1} labels={STEPPER_LABELS}/>
					</div>}
					<div className='dis-flex flex-row justify-space-around text-bold m-t-10'>
						<div className='font-20'>
							{(initialSurvey || ssu) ? "Please complete your first weekly Child Outcome Rating Scale (CORS)" : "Please complete your weekly Child Outcome Rating Scale (CORS)"} 

						</div>
					</div>
					<div className='dis-flex flex-row m-t-40 font-20 text-bold'>
						Tell us about your child
					</div>
					{
						(!initialSurvey && !ssu) && <div className='dis-flex flex-row m-t-40'>
							<div>
								Fill this form according to <b className='bg-yellow'>how you think your child is doing</b>. 
							</div>
						</div>
					}
					{
						(initialSurvey || ssu) && <div className='dis-flex flex-row m-t-10'>
							<div>
								Please mark the scale according to <b className='bg-yellow'>how you think your child is doing</b>. 
							</div>
						</div>
					}
					<div className='dis-flex flex-row'>
						<div >
							The closer to the smiley face, the better things are. The closer to the frowny face, things are not so good. 
						</div>
					</div>
					<div className='dis-flex flex-row m-t-40 '>
						<div>
							Questions marked with a <b className='asterisk-text-color'>*</b> are required
						</div>
					</div>

					<div className='dis-flex flex-row m-t-10'>
						<Container fluid >
							<Row>
								<Col md={col4}></Col>
								<Col md={col8}>
									<div className='image-size dis-flex justify-space-between d-none d-md-flex'>
										<DissatisfiedIcon fontSize='inherit'></DissatisfiedIcon>
										<SatisfiedIcon fontSize='inherit'></SatisfiedIcon>
									</div>
								</Col>
							</Row>
							<Row>
								<Col md={col4}>
									<div><b>Me</b><b className='asterisk-text-color'>*</b><br/>(How are they doing?)</div>
								</Col>
								<Col md={col8} className='slider-row'>
									<div className='image-size dis-flex justify-space-between d-md-none'>
										<DissatisfiedIcon fontSize='inherit'></DissatisfiedIcon>
										<SatisfiedIcon fontSize='inherit'></SatisfiedIcon>
									</div>
									<SliderComponent 
										ariaLabel={"Me Value"} 
										sliderValue={childValue} 
										valueSetter={setChildValue} 
										sliderTouched={sliderChildTouched} 
										setSliderTouched={setSliderChildTouched} 
										toggleShowSliderMessage={toggleShowSliderChildMessage}
										changeSliderValue={changeSliderValue}
									></SliderComponent>
									{/* <Slider
										onChange={(e,value) => changeSliderValue(value, setChildValue, sliderChildTouched, setSliderChildTouched, toggleShowSliderChildMessage)}
										value={childValue}
										aria-label="Me Value"
										defaultValue={0}
										shiftStep={1}
										step={0.1}
										min={0}
										max={9}
									>
									</Slider> */}
									{showSliderChildMessage && showSliderMessage()}
								</Col>
							</Row>
							<Row className='m-t-10'>
								<Col md={col4}>
									<div><b>Family</b><b className='asterisk-text-color'>*</b><br/>(How are things in their family?)</div>
								</Col>
								<Col md={col8} className='slider-row'>
									<div className='image-size dis-flex justify-space-between d-md-none'>
										<DissatisfiedIcon fontSize='inherit'></DissatisfiedIcon>
										<SatisfiedIcon fontSize='inherit'></SatisfiedIcon>
									</div>
									<SliderComponent 
										ariaLabel={"Family Value"} 
										sliderValue={familyValue} 
										valueSetter={setFamilyValue} 
										sliderTouched={sliderFamilyTouched} 
										setSliderTouched={setSliderFamilyTouched} 
										toggleShowSliderMessage={toggleShowSliderFamilyMessage}
										changeSliderValue={changeSliderValue}
									></SliderComponent>
									{showSliderFamilyMessage && showSliderMessage()}
								</Col>
							</Row>
							<Row className='m-t-10'>
								<Col md={col4}>
									<div><b>School</b><b className='asterisk-text-color'>*</b><br/>(How are they doing at school?)</div>
						
								</Col>
								<Col md={col8} className='slider-row'>
									<div className='image-size dis-flex justify-space-between  d-md-none'>
										<DissatisfiedIcon fontSize='inherit'></DissatisfiedIcon>
										<SatisfiedIcon fontSize='inherit'></SatisfiedIcon>
									</div>
									<SliderComponent 
										ariaLabel={"School Value"} 
										sliderValue={schoolValue} 
										valueSetter={setSchoolValue} 
										sliderTouched={sliderSchoolTouched} 
										setSliderTouched={setSliderSchoolTouched} 
										toggleShowSliderMessage={toggleShowSliderSchoolMessage}
										changeSliderValue={changeSliderValue}
									></SliderComponent>
									{showSliderSchoolMessage && showSliderMessage()}
								</Col>
							</Row>
							<Row className='m-t-10'>
								<Col md={col4}>
									<div><b>Everything</b><b className='asterisk-text-color'>*</b><br/>(How is everything going?)</div>
								</Col>
								<Col md={col8} className='slider-row'>
									<div className='image-size dis-flex justify-space-between  d-md-none'>
										<DissatisfiedIcon fontSize='inherit'></DissatisfiedIcon>
										<SatisfiedIcon fontSize='inherit'></SatisfiedIcon>
									</div>
									<SliderComponent 
										ariaLabel={"Everything Value"} 
										sliderValue={everythingValue} 
										valueSetter={setEverythingValue} 
										sliderTouched={sliderEverythingTouched} 
										setSliderTouched={setSliderEverythingTouched} 
										toggleShowSliderMessage={toggleShowSliderEverythingMessage}
										changeSliderValue={changeSliderValue}
									></SliderComponent>
									{showSliderEverythingMessage && showSliderMessage()}
								</Col>
							</Row>
						</Container>
						
					</div>
					<div className='form-seperator'></div>
					{
						initialSurvey 
						&& 
						<div className='dis-flex tnc-container flex-column'>
							<FormControlLabel control={<Checkbox checked={termsOfServiceChecked} onChange={(e) => changeTermsOfService(e.target.checked)}></Checkbox>} label={checkboxText()} />
							{showCheckboxMessage && <div className='asterisk-text-color font-10'>Please agree to the statement</div>}
						</div>
					}
					<div className='dis-flex'>
						<Button 
						style={{background: !isSubmitting && 'var(--theme-pink)', padding: '10px 50px', textTransform: 'none'}} 
						variant='contained' 
						onClick={submitForm} 
						fullWidth={false} 
						disabled={isSubmitting}>
							{isSubmitting && <CircularProgress size={20} />}
							<b className={isSubmitting && "p-l-6"}>
								{(initialSurvey || ssu) ? " Get Game Key" : " Submit"}
							</b>
						</Button>
					</div>
				</div>
			}
			{
				SSUSurveyCompleted && <GetStartedComponent steps={STEPPER_LABELS}/>
			}
			<div className='dis-flex flex-column flex-grow-3'></div>
		</div>
	)

}

export default FormComponent;